export default __webpack_public_path__ + "static/log-ffeae0fdaf629fda9c07e1eb90046402.png";